import combineEvents from '@redux-beacon/combine-events';
import GoogleTagManager from '@redux-beacon/google-tag-manager';
import logger from '@redux-beacon/logger';
import { createMiddleware } from 'redux-beacon';

import ACTIONS from 'state/constants';
import Environment from 'utils/Environment';

import { componentShownEvent, trackNavigation, signUpForNewsletter } from './app';
import { upsellAddToCart, addMultipleLineItemEvent } from './cart';
import {
  trackCollectionPageSetFilter,
  trackCollectionPageClearFilters,
  trackCollectionPageOpenFilterDrawer,
} from './collection-page';
import {
  openStoryCardModalEvent,
  setMasterProductCardProduct,
  setMasterProductCardCarouselIndex,
} from './collections';
import {
  legacyAddMultipleLineItemEvent,
  removeLineItemEvent,
  updateLineItemEvent,
  viewProductEvent,
  iterableUpdateCart,
  reportDYRecommendationsClick,
} from './enhanced-ecomm';
import { trackEvent, trackCTAClickEvent } from './general';
import { openGeofencingShopSelectorEvent, selectShopEvent } from './geofencing';
import {
  openSizeChartEvent,
  signUpForProductUpdates,
  openProductUpdatesFormEvent,
  trackProductUpdatesTooltipView,
  trackProductSelectorCarouselScroll,
  trackOpenAttribute,
  trackViewDifferentiatorsClick,
  trackCloseAddToCartModal,
  trackStoreInventoryDropdownEvent,
  trackStoreInventoryModalEvent,
} from './pdp';
import { trackDYRecsClick, trackDYAPICampaignAssignment } from './personalization';
import { startReturnsEvent } from './returns';
import { setCurrentNavigationNode } from './top-navigation';

const eventsMap = {
  [ACTIONS.TRACK_EVENT]: trackEvent,
  [ACTIONS.TRACK_CTA_CLICK_EVENT]: trackCTAClickEvent,
  [ACTIONS.ADD_LINE_ITEMS_SUCCESS]: combineEvents(
    legacyAddMultipleLineItemEvent,
    addMultipleLineItemEvent,
    upsellAddToCart,
    iterableUpdateCart
  ),
  [ACTIONS.SIGN_UP_NEWSLETTER_REQUEST]: signUpForNewsletter,
  [ACTIONS.SIGN_UP_PRODUCT_UPDATES_REQUEST]: signUpForProductUpdates,
  [ACTIONS.REMOVE_LINE_ITEM_SUCCESS]: combineEvents(removeLineItemEvent, iterableUpdateCart),
  [ACTIONS.UPDATE_LINE_ITEM_SUCCESS]: combineEvents(updateLineItemEvent, iterableUpdateCart),
  [ACTIONS.SET_GEOFENCING_SHOP_SELECTION]: selectShopEvent,
  [ACTIONS.OPEN_MODAL]: combineEvents(
    openSizeChartEvent,
    openGeofencingShopSelectorEvent,
    openStoryCardModalEvent,
    openProductUpdatesFormEvent
  ),
  [ACTIONS.TRACK_COMPONENT_MOUNT]: componentShownEvent,
  [ACTIONS.SET_CURRENT_PRODUCT]: viewProductEvent,
  [ACTIONS.SET_CURRENT_ATTRIBUTE_INDEX]: trackOpenAttribute,
  [ACTIONS.TRACK_VIEW_DIFFERENTIATORS_CLICK]: trackViewDifferentiatorsClick,
  [ACTIONS.TRACK_CLOSE_ADD_TO_CART_MODAL]: trackCloseAddToCartModal,
  [ACTIONS.TRACK_STORE_INVENTORY_DROPDOWN_ACTION]: trackStoreInventoryDropdownEvent,
  [ACTIONS.TRACK_STORE_INVENTORY_MODAL_ACTION]: trackStoreInventoryModalEvent,
  [ACTIONS.TRACK_NAVIGATION]: trackNavigation,
  [ACTIONS.SET_CURRENT_TOP_NAVIGATION_NODE]: setCurrentNavigationNode,
  [ACTIONS.SUBMIT_RETURNS_PAGE]: startReturnsEvent,
  [ACTIONS.TRACK_PRODUCT_UPDATES_TOOLTIP_VIEW]: trackProductUpdatesTooltipView,
  [ACTIONS.TRACK_PDP_PRODUCT_SELECTOR_CAROUSEL_SCROLL]: trackProductSelectorCarouselScroll,
  [ACTIONS.SET_MASTER_PRODUCT_CARD_PRODUCT]: setMasterProductCardProduct,
  [ACTIONS.SET_MASTER_PRODUCT_CARD_CAROUSEL_INDEX]: setMasterProductCardCarouselIndex,
  [ACTIONS.SET_COLLECTION_PAGE_FILTER]: trackCollectionPageSetFilter,
  [ACTIONS.CLEAR_COLLECTION_PAGE_FILTERS]: trackCollectionPageClearFilters,
  [ACTIONS.OPEN_COLLECTION_PAGE_FILTER_DRAWER]: trackCollectionPageOpenFilterDrawer,
  [ACTIONS.TRACK_DY_RECS_CLICK]: trackDYRecsClick,
  [ACTIONS.REPORT_DY_RECS_CLICK]: reportDYRecommendationsClick,
  [ACTIONS.TRACK_DY_API_CAMPAIGN_ASSIGNMENT]: trackDYAPICampaignAssignment,
};

const gtm = GoogleTagManager();

const getExtensions = () => (Environment.isDev ? { logger } : undefined);

const gtmMiddleware = createMiddleware(eventsMap, gtm, getExtensions());

export default gtmMiddleware;

export { getExtensions };
